import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import ReactPaginate from 'react-paginate';
import { utils, writeFile } from 'xlsx';
import BookingServices from '../services/BookingServices';
import SelectOrderStatus from './TogelButton/SelectOrderStatus';
import BookingUpdate from './Update Model/bookingUpdate';
import DeleteButton from './Button/DeleteButton';
import { useLocation } from 'react-router-dom';
import ViewOrder from './View Model/ViewOrder';
import { FaRegEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'

Modal.setAppElement('#root');

function TodayPendingOrder() {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get('userId');
  const [data, setData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [run, setRun] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const itemsPerPage = 10;

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = userId
          ? await BookingServices.getUserBooking(userId)
          : await BookingServices.gettodaybookingPendingdata();
        setData(response?.data?.totalBookingsToday || []);

        console.warn(response.data.totalBookingsToday);
      } catch (err) {
        console.error('Error fetching bookings:', err);
      }
    };
    fetchData();
  }, [userId, run]);
  console.log(data);
  const handleEditDetails = (order) => {
    setSelectedEdit(order);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (order) => {
    setSelectedEdit(order);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => setIsEditModalOpen(false);
  const closeDeleteModal = () => setIsDeleteModalOpen(false);

  const toggleActionMenu = (index) =>
    setActiveIndex(index === activeIndex ? null : index);

  const handleSearch = (e) => setSearchQuery(e.target.value);
  const handleStatusFilterChange = (e) => setStatusFilter(e.target.value);

  const formatDateTime = (isoString) => {
    if (!isoString) return 'N/A';
    const date = new Date(isoString);
    return date.toLocaleDateString('en-GB');
  };

  const filteredBookings = Array.isArray(data) && data.length > 0
    ? data
      .filter((order) => {
        const searchLower = searchQuery?.toString().toLowerCase() || "";
        const firstName = order?.user?.firstName?.toString().toLowerCase() || "";
        const lastName = order?.user?.lastName?.toString().toLowerCase() || "";
        const brandName = order?.vehicle?.brand?.name?.toString().toLowerCase() || "";
        const modelName = order?.vehicle?.model?.name?.toString().toLowerCase() || "";
        const bookingId = order?.bookingId?.toString().toLowerCase() || "";
        const paymentType = order?.paymentType?.toString().toLowerCase() || "";

        return (
          firstName.includes(searchLower) ||
          lastName.includes(searchLower) ||
          brandName.includes(searchLower) ||
          modelName.includes(searchLower) ||
          bookingId.includes(searchLower) ||
          paymentType.includes(searchLower)
        );
      })
      .filter((order) => {
        if (statusFilter) {
          const orderStatus = order?.status?.toString().toLowerCase() || "";
          return orderStatus === statusFilter.toLowerCase();
        }
        return true;
      })
    : [];


  const indexOfLastBooking = currentPage * itemsPerPage;
  const indexOfFirstBooking = indexOfLastBooking - itemsPerPage;
  const currentBookings = filteredBookings?.slice(
    indexOfFirstBooking,
    indexOfLastBooking
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const downloadOrder = () => {
    const formattedData = filteredBookings.map((order, index) => ({
      '#': index + 1,
      'Order ID': order?.bookingId || 'N/A',
      'Customer Name': `${order?.user?.firstName || 'N/A'} ${order?.user?.lastName || ''
        }`.trim(),
      'Vehicle Brand': order?.vehicle?.brand?.name || 'N/A',
      'Vehicle Model': order?.vehicle?.model?.name || 'N/A',
      'Vehicle Number Plate': order?.vehicle?.numberPlate || 'N/A',
      'Plan Name': order?.plan?.name || 'N/A',
      'Service Title': order?.service?.title || 'N/A',
      'Total Price': order?.totalPrice || 'N/A',
      'Booking Date': formatDateTime(order?.bookingDate),
      'Booking Time': order?.bookingTime || 'N/A',
      'Customer Mobile': order?.user?.mobileNo || 'N/A',
      'Payment Type': order?.paymentType || 'N/A',
      'Order Status': order?.status || 'N/A',
    }));

    const worksheet = utils.json_to_sheet(formattedData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'Orders');
    writeFile(workbook, 'Orders.xlsx');
  };


  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">Today Order List  <span className="badge bg-orange">{filteredBookings?.length}</span></h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                 Today Order
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center">

              <Link className="round-add-btn" to={`/dashboard`}>
                              Back
               </Link>

            <div className="pe-1 mb-xl-0">
              <button className="excel-btn" onClick={downloadOrder}><img src="img/excel.svg" alt="Download" />Download</button>
            </div>
          </div>
        </div>

        <div className="container-box px-0" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearch}
                    className='form-control'
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>

          </div>
          
          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Order ID</th>
                  <th>C NAME</th>
                  <th>C MOBILE NO</th>
                  <th>SERVICE TYPE</th>
                  <th>PRICE</th>
                  <th>PAYMENT TYPE</th>
                  <th>SLOT TIME</th>
                  <th>BOOKING DATE</th>
                  <th>VENDOR MOBILE NO</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {currentBookings?.map((order, index) => (
                  <tr key={index}>
                    <td>{index + 1 + indexOfFirstBooking}</td>
                    <td>{order?.bookingId || "N/A"}</td>
                    <td>{`${order?.user?.firstName || "N/A"} ${order?.user?.lastName || ""}`.trim() || "N/A"}</td>
                    <td>{order?.user?.mobileNo || "N/A"}</td>
                    <td>{order?.service?.title || "N/A"}</td>
                    <td>{order?.totalPrice || "N/A"}</td>
                    <td>{order?.paymentType || "N/A"}</td>
                    <td>{order?.bookingTime || "N/A"}</td>
                    <td>{formatDateTime(order?.bookingDate || "N/A")}</td>
                    <td>{order?.vendor?.mobileNo || "N/A"}</td>
                    <td
                      style={{
                        color:
                          order?.status === "Pending"
                            ? "red"
                            : order?.status === "Completed"
                              ? "green"
                              : order?.status === "OutOfDelivery"
                                ? "orange"
                                : "black",
                      }}
                    >
                      {order?.status === "OutOfDelivery" ? "On The Way" : order?.status || "N/A"}
                    </td>

                    <td className="view-cities-button" onClick={() => handleViewDetails(order)}>
                      <FaRegEye className="custom-icon" />
                      <Tooltip id="view-cities-tooltip" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              pageCount={Math.ceil(filteredBookings?.length / itemsPerPage)}
              onPageChange={({ selected }) => paginate(selected + 1)}
              containerClassName={'pagination'}
              activeClassName={'active'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              nextClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
            />

          </div>

        </div>
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <BookingUpdate order={selectedEdit} closeModal={closeEditModal} onSuccess={() => { setRun(run + 1) }} />
        </Modal>


        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="Order Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <ViewOrder order={selectedOrder} closeModal={closeModal} />
        </Modal>


        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="Order" closeModal={closeDeleteModal} onSuccess={() => { setRun(run + 1) }} />
        </Modal>


      </div>
    </>
  );
}
export default TodayPendingOrder;



